import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Cog } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Logo } from '@/components/logos/logo';
import { IntegrationV2Properties } from '@/gql/graphql';
import { getStatusIndicatorColor, LOGO_MAPPING, readableStatus } from '../tracking-utils';

interface TrackingDestinationCardProps {
  integration: IntegrationV2Properties;
}

export const TrackingDestinationCard: React.FC<TrackingDestinationCardProps> = ({
  integration
}) => {
  const navigate = useNavigate();

  const iconKey = integration.__typename
    ? LOGO_MAPPING[integration.type]
    : integration.id == 'shopify'
      ? 'shopify'
      : integration.id == 'sub-domain'
        ? 'subdomain'
        : 'unspecified';
  const navigateTo = integration.__typename
    ? `./integrations/${integration.id}`
    : `./${integration.id}`;

  return (
    <div
      key={integration.id}
      className="h-[210px] w-full bg-card border rounded-lg shadow-sm flex flex-col"
    >
      <div className="py-4 px-6 flex-grow">
        <div className="flex items-start space-x-2 pt-2 h-12">
          {iconKey !== 'unspecified' && (
            <div className="bg-white p-2 rounded-md flex items-center justify-center w-10 h-10 border shadow-sm">
              <Logo icon={iconKey} width={24} height={24} />
            </div>
          )}
        </div>
        <div className="mt-4">
          <h3 className="text-base font-semibold text-card-foreground">{integration.name}</h3>
        </div>
      </div>
      <div className="flex justify-between items-center border-t px-6 h-[68px] flex-shrink-0">
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            void navigate(navigateTo);
          }}
          className="bg-transparent h-9"
        >
          <Cog size={16} className="mr-2" />
          Settings
        </Button>
        {integration.__typename && (
          <div className="flex items-center space-x-3">
            <span className="text-xs font-medium text-muted-foreground">
              {readableStatus(integration.status)}
            </span>
            <div
              className={`w-4 h-4 rounded-full ${getStatusIndicatorColor(integration.status)}`}
            />
          </div>
        )}
      </div>
    </div>
  );
};
